import React from "react";
import * as styleVars from "../../../styles/_variables.scss";

function BurgerMenuIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" viewBox="0 0 30 21">
        <g fill={styleVars.primary} fillRule="evenodd">
            <rect width="20" height="4" x="10" y="9" rx="2"/>
            <rect width="30" height="4" rx="2"/>
            <rect width="30" height="4" y="17" rx="2"/>
        </g>
    </svg>  
  );
}

export default BurgerMenuIcon;